<!--公告及新闻稿-->
<template>
  <!--内容-->
  <div class="content_width_box">
    <div class="tishixiaoxi">
      公司通讯可于本公司的网站（<a href="www.kingsoft.com" target="_blank">www.kingsoft.com</a>）及香港联合交易所有限公司网站（<a href="www.hkexnews.hk" target="_blank">www.hkexnews.hk</a>）查阅。可供采取行动的公司通讯* 将通过登记股东提供的电子邮件地址或以印刷版本个别发送。
      <br><br>
      倘阁下需要公司通讯的印刷本，可以通过发送邮件至股份过户处香港中央证券登记有限公司的邮箱<a href="mailto:kingsoft.ecom@computershare.com.hk">kingsoft.ecom@computershare.com.hk</a>提出有关要求。
      <br><br>
      倘阁下需要选择/更换接受公司通讯的方式，及/或提供/更改电子联络资料，请联系股份过户处香港中央证券登记有限公司（适用于已登记股东）或阁下持有股份的银行、经纪、托管商、代理人或香港中央结算（代理人）有限公司（适用于非登记股东）。
      <br><br>
      <div class="little">* 可供采取行动的公司通讯指任何涉及要求本公司的证券持有人指示其拟如何行使其有关证券持有人的权利或作出选择的公司通讯。</div>
    </div>
    <div class="content_title">
      <div class="title_left_h2">公告及新闻稿</div>
      <div class="title_right_tab">
        <div class="tab1" @click="clickTab('公告')">公告</div>
        <div class="tab2" @click="clickTab('新闻稿')">新闻稿</div>
      </div>
    </div>
    <div class="select_box">
      <multiselect v-show="selectedItem == '公告'" v-model="yearSelected" 
        :options="['全部年份',...this.conditionNewsList.yearList]" 
        :searchable="false" :close-on-select="true" :show-labels="false" placeholder="选择年份"></multiselect>
      <multiselect v-show="selectedItem == '新闻稿'" v-model="yearNoticeSelected" 
      :options="['全部年份',...this.conditionNoticeList.yearList]" 
      :searchable="false" :close-on-select="true" :show-labels="false" placeholder="选择年份"></multiselect>
    </div>
    <YearsTitleListView v-show="selectedItem == '公告'" :messageList="conditionNewsList.list" :perPage="conditionNewsList.perPage" detailRouter="invstorDetail" :yearSelected="yearSelected"></YearsTitleListView>
    <YearsTitleListView v-show="selectedItem == '新闻稿'" :messageList="conditionNoticeList.list" :perPage="conditionNoticeList.perPage" detailRouter="invstorDetail" :yearSelected="yearNoticeSelected"></YearsTitleListView>
  </div>  
</template>
<script>

import YearsTitleListView from '../../titleNews/YearsTitleListView'
import UtilEvent from '../../utils/UtilEvent.js'
  export default {
    name: 'investorReport',
    components:{UtilEvent,YearsTitleListView},
    props: ['conditionNewsList',],
    created(){
        
    },
    data () {
      return {
        yearSelected:'全部年份',
        yearNoticeSelected:'全部年份',
        selectedItem:'公告',
        conditionNoticeList:{total:0,perPage:1,yearList:[],list:[]}
      }
    },
    computed:{
      
    },
    methods:{
      clickTab(item){
       
        this.selectedItem = item;
        if(item == '新闻稿' && this.conditionNoticeList.list && this.conditionNoticeList.list.length == 0){
          new UtilEvent().getNoticeListData(this)
        }
      }
      
    },
    watch:{
      
    },
    mounted(){
      
    },
   
  }
  </script>

